import { Container } from '@/components/ui/container';
import { LinkPreview } from '@/components/ui/link-preview';

export default function LandingCta(): JSX.Element {
	return (
		<Container className="max-w-3xl relative">
			<div className="text-center max-w-3xl mx-auto">
				<h2 className="text-3xl md:text-4xl font-bold mb-6 font-space-grotesk">
					Every business is different. That&apos;s why we start with a conversation.
				</h2>
				<div className="text-lg text-muted-foreground mb-8">
					Not sure what you need? Let&apos;s explore it together.
				</div>
				<div className="text-lg text-muted-foreground mb-8">
					Book a{' '}
					<LinkPreview
						url="https://app.hellobonsai.com/s/joviancloudworks/discovery-call"
						className="font-bold"
						target="_blank"
						rel="noopener noreferrer"
					>
						Discovery Session
					</LinkPreview>{' '}
					or start with a free{' '}
					<LinkPreview url="/tools/tech-audit-assessment" className="font-bold">
						Tech Assessment
					</LinkPreview>{' '}
					or{' '}
					<LinkPreview url="/tools/automation-roi-calculator" className="font-bold">
						ROI Calculator
					</LinkPreview>
					.
				</div>
			</div>
		</Container>
	);
}
